import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  genElObject,
  genElText,
  genElDate,
  genElTextPassword,
  genElZirvuFileManager,
} from "../../../components/utils/EditorDialogElementGenerator";
import GrupSelectorDialog from "../../../dialogs/selectors/GrupSelectorDialog";
import KaryawanSelectorDialog from "../../../dialogs/selectors/KaryawanSelectorDialog";
import JenisSelectorDialog from "../../../dialogs/selectors/JenisSelectorDialog";
import PemakaianSelectorDialog from "../../../dialogs/selectors/PemakaianSelectorDialog";
import { Divider } from "@mui/material";

const editTitle = "Edit Kendaraan";
const addTitle = "Tambah Kendaraan";

const KendaraanEditorDialog = (props) => {
  const {
    visible,
    onHide,
    onConfirm,
    loading,
    title,
    data,
    setData,
    addNewMode,
    error,
    setError,
  } = props;

  // dialog state
  const [showGrupSelector, setShowGrupSelector] = React.useState(false);
  const [showSupirSelector, setShowSupirSelector] = React.useState(false);
  const [showJenisSelector, setShowJenisSelector] = React.useState(false);
  const [showPemakaianSelector, setShowPemakaianSelector] =
    React.useState(false);

  /**
   * Validates the form data.
   *
   * @returns {boolean} - Returns true if the data is valid, otherwise false.
   * @returns {object} - Returns an object containing the error messages, format { field: message}.
   */
  const validate = () => {
    let valid = true;
    let newEror = {};

    if (!valid) setError(newEror);

    return valid;
  };

  // handle UI event section

  const handleOnClickGrup = () => {
    setShowGrupSelector(true);
  };

  const handleOnConfirmGrup = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_kendaraan_grup: selected,
        kendaraan_grup_id: selected.id,
      });
      setShowGrupSelector(false);
    }
    return selected;
  };

  const handleOnClickJenis = () => {
    setShowJenisSelector(true);
  };

  const handleOnConfirmJenis = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_kendaraan_jenis: selected,
        kendaraan_jenis_id: selected.id,
      });
      setShowJenisSelector(false);
    }
    return selected;
  };

  const handleOnClickSupir = () => {
    setShowSupirSelector(true);
  };

  const handleOnConfirmSupir = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_supir_tetap: selected,
        data_supir_tetap_id: selected.id,
      });
      setShowSupirSelector(false);
    }
    return selected;
  };

  const handleOnClickPemakaian = () => {
    setShowPemakaianSelector(true);
  };

  const handleOnConfirmPemakaian = (event, datas) => {
    let selected;
    event.preventDefault();
    if (datas && datas.length > 0) {
      selected = datas[0];
      setData({
        ...data,
        data_kendaraan_pemakaian: selected,
        kendaraan_pemakaian_id: selected.id,
      });
      setShowPemakaianSelector(false);
    }
    return selected;
  };

  /**
   * Generate Dialog Form Element
   *
   * various function to generate
   *
   * genElText({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextPassword({ field, name, data, setData, disabled, autoFocus, error })
   * genElTextDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElNumber({ field, name, data, setData, min_fraction_digits, max_fraction_digits, min, max, disabled, autoFocus, error })
   * genElNumberDropdown({ field, name, data, setData, options, disabled, autoFocus, error, optionLabel = "name" })
   * genElBoolean({ field, name, data, setData, labelTrue = "Ya", labelFalse = "Tidak", disabled, autoFocus, error })
   * genElDate({ field, name, data, setData, primeFormat, min, max, showTime, time, month, year, disabled, autoFocus, error })
   * genElObject({ field, name, value, onClick, selectorGenerator, disabled, autoFocus, error })
   */

  const elGrup = genElObject({
    field: "data_kendaraan_grup.nama",
    name: "Grup",
    value: data.data_kendaraan_grup ? data.data_kendaraan_grup.nama : "",
    onClick: handleOnClickGrup,
  });
  const elSupir = genElObject({
    field: "data_supir_tetap.nama",
    name: "Supir",
    value: data.data_supir_tetap ? data.data_supir_tetap.nama : "",
    onClick: handleOnClickSupir,
  });
  const elJenis = genElObject({
    field: "data_kendaraan_jenis.nama",
    name: "Jenis",
    value: data.data_kendaraan_jenis ? data.data_kendaraan_jenis.nama : "",
    onClick: handleOnClickJenis,
  });
  const elPemakaian = genElObject({
    field: "data_kendaraan_pemakaian.nama",
    name: "Pemakaian",
    value: data.data_kendaraan_pemakaian
      ? data.data_kendaraan_pemakaian.nama
      : "",
    onClick: handleOnClickPemakaian,
  });
  const elJenisMobil = genElText({
    field: "jenis_mobil",
    name: "Jenis Mobil",
    data,
    setData,
    error,
  });
  const elNopol = genElText({
    field: "nomor_polisi",
    name: "Nomor Polisi",
    data,
    setData,
    error,
  });
  const elTahun = genElText({
    field: "tahun",
    name: "Tahun",
    data,
    setData,
    error,
  });
  const elMerek = genElText({
    field: "merek",
    name: "Merek",
    data,
    setData,
    error,
  });
  const elJenisBBM = genElText({
    field: "jenis_bbm",
    name: "Jenis BBM",
    data,
    setData,
    error,
  });
  const elTanggalBeli = genElDate({
    field: "tanggal_beli",
    name: "Tanggal Beli",
    primeFormat: "dd MM yy",
    data,
    setData,
    error,
  });
  const elTanggalSTNK = genElDate({
    field: "tanggal_stnk",
    name: "Tanggal STNK",
    primeFormat: "dd MM yy",
    data,
    setData,
    error,
  });
  const elTanggalPajak = genElDate({
    field: "tanggal_pajak",
    name: "Tanggal Pajak",
    primeFormat: "dd MM yy",
    data,
    setData,
    error,
  });
  const elKeterangan = genElText({
    field: "keterangan",
    name: "Keterangan",
    data,
    setData,
    error,
  });
  // const elKode = genElText({
  //   field: "nik",
  //   name: "NIK",
  //   data,
  //   setData,
  //   error,
  // });
  //   const elJabatan = genElObject({
  //     field: "jabatan",
  //     name: "Jabatan",
  //     value: data.data_jabatan ? data.data_jabatan.nama : "",
  //     onClick: handleOnClickJabatan,
  //   });
  //   const elUserName = genElText({
  //     field: "data_user.username",
  //     name: "User Name",
  //     data,
  //     setData,
  //     error,
  //   });
  //   const elUserEmail = genElText({
  //     field: "data_user.email",
  //     name: "Email",
  //     data,
  //     setData,
  //     error,
  //   });
  //   const elUserPassword = genElTextPassword({
  //     field: "data_user.password",
  //     name: "Password",
  //     data,
  //     setData,
  //     error,
  //   });
  //   const elUserCPassword = genElTextPassword({
  //     field: "data_user.cpassword",
  //     name: "Confirm Password",
  //     data,
  //     setData,
  //     error,
  //   });
  //   const elSignature = genElZirvuFileManager({
  //     field: "signature",
  //     name: "Tanda Tangan",
  //     data,
  //     setData,
  //     error,
  //   });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          const valid = validate();
          if (valid) {
            onConfirm(data);
          }
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "45rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={addNewMode ? addTitle : editTitle}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
    >
      <GrupSelectorDialog
        title={"Pilih Grup"}
        visible={showGrupSelector}
        onHide={() => setShowGrupSelector(false)}
        onConfirm={handleOnConfirmGrup}
      />

      <KaryawanSelectorDialog
        title="Pilih Supir"
        visible={showSupirSelector}
        onHide={() => setShowSupirSelector(false)}
        onConfirm={handleOnConfirmSupir}
        additionalFilter={"jabatan_id:=:2"}
      />

      <JenisSelectorDialog
        title={"Pilih Jenis"}
        visible={showJenisSelector}
        onHide={() => setShowJenisSelector(false)}
        onConfirm={handleOnConfirmJenis}
      />

      <PemakaianSelectorDialog
        title={"Pilih Pemakaian"}
        visible={showPemakaianSelector}
        onHide={() => setShowPemakaianSelector(false)}
        onConfirm={handleOnConfirmPemakaian}
      />

      <div className="col-start-center relative h-100">
        <div className={`row-start-start w-100 gap-3`}>
          <div className="col-start-start w-100 gap-3">
            {elGrup}
            {elSupir}
            {elJenis}
            {elPemakaian}
            {elJenisMobil}
            {elNopol}
            {elTahun}
          </div>
          <Divider layout="vertical" className="h-[23.7rem]" />
          <div className="col-start-start w-full gap-3">
            {elMerek}
            {elJenisBBM}
            {elTanggalBeli}
            {elTanggalSTNK}
            {elTanggalPajak}
            {elKeterangan}
            {/* {elJabatan}
            {elUserPassword}
            {elUserCPassword} */}
          </div>
        </div>
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default KendaraanEditorDialog;
